import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4514b604"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "client-skin-options" }
const _hoisted_3 = ["aria-pressed", "onClick"]
const _hoisted_4 = {
  key: 0,
  "aria-hidden": "true"
}

import {ref,watch,onBeforeUnmount} from 'vue'
import {message} from 'ant-design-vue'
import store from '@/store'
import {miniappSkins} from '@/config/miniappSkins'
import {usePersonalAdminSkin,selectPersonalAdminSkin,currentAdminSkin} from '@/utils/adminSkin'

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminSkinPicker',
  setup(__props) {

const iconOnly=true,visible=ref(false),selected=ref('classic')
const skins=miniappSkins.map(s=>({id:s.value,name:s.label,color:s.colors[0]}))
watch(()=>JSON.stringify([store.getters.userInfo?.orgId,store.getters.userInfo?.id]),()=>{visible.value=false;usePersonalAdminSkin(Number(store.getters.userInfo?.orgId),Number(store.getters.userInfo?.id))},{immediate:true})
const openPicker=()=>{selected.value=currentAdminSkin();visible.value=true}
const choose=(id:string|null)=>{if(!selectPersonalAdminSkin(Number(store.getters.userInfo?.orgId),Number(store.getters.userInfo?.id),id)){message.warning('暂时无法保存皮肤选择，请稍后重试。');return}selected.value=currentAdminSkin()}
onBeforeUnmount(()=>usePersonalAdminSkin(0,0))

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["client-skin-entry", {'icon-only':iconOnly}]),
      "aria-label": "皮肤",
      title: "皮肤",
      onClick: openPicker
    }, [
      iconOnly
        ? (_openBlock(), _createBlock(_component_svg_icon, {
            key: 0,
            icon: "client-skin"
          }))
        : (_openBlock(), _createElementBlock("span", _hoisted_1, "皮肤"))
    ], 2),
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
      title: "选择皮肤",
      footer: null,
      width: 480
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(skins), (skin) => {
            return (_openBlock(), _createElementBlock("button", {
              key: skin.id,
              type: "button",
              "aria-pressed": selected.value===skin.id,
              onClick: ($event: any) => (choose(skin.id))
            }, [
              _createElementVNode("span", {
                class: "swatch",
                style: _normalizeStyle({background:skin.color}),
                "aria-hidden": "true"
              }, null, 4),
              _createElementVNode("span", null, _toDisplayString(skin.name), 1),
              (selected.value===skin.id)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "✓"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_3))
          }), 128))
        ]),
        _createVNode(_component_a_button, {
          class: "restore-shop-skin",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (choose(null)))
        }, {
          default: _withCtx(() => [
            _createTextVNode("恢复店铺默认")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})